import { gql } from '@apollo/client';

export const QUERY_CLIENTS = gql`
    query users (
        $filters: UsersPermissionsUserFiltersInput,
        $pagination: PaginationArg,
        $sort: [String] = []
    ) {
        usersPermissionsUsers (filters: $filters, pagination: $pagination, sort: $sort) {
            data {
                id
                attributes {
                    client {
                        data {
                            id
                            attributes {
                                firstName
                                lastName
                                color
                                birthDate
                                avatar {
                                    data {
                                        attributes {
                                            previewUrl
                                            url
                                        }
                                    }
                                }
                                gym {
                                    data {
                                        attributes {
                                            name
                                            address
                                        }
                                    }
                                }
                            }
                        }
                    }
                    parent {
                        data {
                            id
                            attributes {
                                firstName
                                lastName
                                color
                                birthDate
                                avatar {
                                    data {
                                        attributes {
                                            previewUrl
                                            url
                                        }
                                    }
                                }
                                gym {
                                    data {
                                        attributes {
                                            name
                                            address
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            meta {
                pagination {
                    page
                    pageCount
                    pageSize
                    total
                }
            }
        }
    }
`;

export const QUERY_CLIENT = gql`
    query client (
        $id: ID,
        $messages_filters: MessageFiltersInput,
        $messages_sort: [String] = [],
        $messages_pagination: PaginationArg,
    ) {
        usersPermissionsUser(id: $id) {
            data {
                id
                attributes {
                    role {
                        data {
                            id
                            attributes {
                                name
                            }
                        }
                    }
                    contacts {
                        type
                        value
                        data
                    }
                    publicKey
                    parent {
                        data {
                            id
                            attributes {
                                firstName
                                lastName
                                birthDate
                                color
                                avatar {
                                    data {
                                        id
                                        attributes {
                                            url
                                        }
                                    }
                                }
                                bonus
                                schoolUrl
                                anket {
                                    experience
                                    contraindications
                                    fullFamily
                                    gadgetTime
                                    mainGoal
                                }
                                indicator {
                                    id
                                    name
                                    goal
                                    startValue
                                    result {
                                        id
                                        date
                                        value
                                    }
                                }
                                skill {
                                    id
                                    name
                                    own
                                }
                                project {
                                    data {
                                        id
                                        attributes {
                                            name
                                            color
                                            logo {
                                                data {
                                                    id
                                                    attributes {
                                                        url
                                                    }
                                                }
                                            }
                                            cover {
                                                data {
                                                    id
                                                    attributes {
                                                        url
                                                    }
                                                }
                                            }
                                            levels
                                            links
                                            experiences
                                        }
                                    }
                                }
                                projectData
                                clients {
                                    data {
                                        id
                                        attributes {
                                            firstName
                                            lastName
                                            account {
                                                data {
                                                    id
                                                }
                                            }
                                        }
                                    }
                                }
                                messages (filters: $messages_filters, sort: $messages_sort, pagination: $messages_pagination) {
                                    data {
                                        id
                                        attributes {
                                            createdAt
                                            author {
                                                data {
                                                    id
                                                    attributes {
                                                        firstName
                                                        lastName
                                                        color
                                                        avatar {
                                                            data {
                                                                id
                                                                attributes {
                                                                    url
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            message
                                        }
                                    }
                                }
                            }
                        }
                    }
                    client {
                        data {
                            id
                            attributes {
                                firstName
                                lastName
                                birthDate
                                color
                                avatar {
                                    data {
                                        id
                                        attributes {
                                            url
                                        }
                                    }
                                }
                                bonus
                                schoolUrl
                                anket {
                                    experience
                                    contraindications
                                    fullFamily
                                    gadgetTime
                                    mainGoal
                                }
                                indicator {
                                    id
                                    name
                                    goal
                                    startValue
                                    result {
                                        id
                                        date
                                        value
                                    }
                                }
                                skill {
                                    id
                                    name
                                    own
                                }
                                project {
                                    data {
                                        id
                                        attributes {
                                            name
                                            color
                                            logo {
                                                data {
                                                    id
                                                    attributes {
                                                        url
                                                    }
                                                }
                                            }
                                            cover {
                                                data {
                                                    id
                                                    attributes {
                                                        url
                                                    }
                                                }
                                            }
                                            levels
                                            links
                                            experiences
                                        }
                                    }
                                }
                                projectData
                                messages (filters: $messages_filters, sort: $messages_sort, pagination: $messages_pagination) {
                                    data {
                                        id
                                        attributes {
                                            createdAt
                                            author {
                                                data {
                                                    id
                                                    attributes {
                                                        firstName
                                                        lastName
                                                        color
                                                        avatar {
                                                            data {
                                                                id
                                                                attributes {
                                                                    url
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            message
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const MUTATION_UPDATE_USER = gql`
    mutation updateUsersPermissionsUser($id: ID!, $data: UsersPermissionsUserInput!) {
        updateUsersPermissionsUser(id: $id, data: $data) {
            data {
                id
            }
        }
    }
`;